import { render, staticRenderFns } from "./EmployeeTaxCardForm.vue?vue&type=template&id=675d054e&scoped=true&"
import script from "./EmployeeTaxCardForm.vue?vue&type=script&lang=ts&"
export * from "./EmployeeTaxCardForm.vue?vue&type=script&lang=ts&"
import style0 from "./EmployeeTaxCardForm.vue?vue&type=style&index=0&id=675d054e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675d054e",
  null
  
)

export default component.exports